export function DefaultOverride(props) {
    return props.children;
}
//# sourceMappingURL=override.js.map